import { useState, useEffect, useRef } from "react";
import "./BerthDateSlotModal.css";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";

const today = dayjs();

export const BerthDateSlotModal = ({
  open,
  handleClose,
  handleDateSlotSelection,
  title = "Select berth availability period",
  values = null,
  mode = "availability",
  chargeType = null,
}) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [allDatesDisabled, setAllDatesDisabled] = useState(false);

  // Get availability date constraints for fixed price mode
  const availabilityStartDate = values?.berthAvailableDate ? dayjs(values.berthAvailableDate) : null;
  const availabilityEndDate = values?.berthAvailableUntil ? dayjs(values.berthAvailableUntil) : null;

  // Determine min/max dates based on mode
  const minDate = mode === "fixedPrice" && availabilityStartDate ? availabilityStartDate : today;
  const maxDate = mode === "fixedPrice" && availabilityEndDate ? availabilityEndDate : null;
  // const [dateArray, setDateArray] = useState([]);

useEffect(() => {
    if (open && values) {
      if (mode === "availability") {
        // Initialize with existing availability values if they exist
        const existingStart = values?.berthAvailableDate ? dayjs(values.berthAvailableDate) : null;
        const existingEnd = values?.berthAvailableUntil ? dayjs(values.berthAvailableUntil) : null;
        setStartDate(existingStart);
        setEndDate(existingEnd);
      } else if (mode === "fixedPrice") {
        // Initialize with existing fixed price period values if they exist
        const existingStart = values?.fixedPeriodStartDate ? dayjs(values.fixedPeriodStartDate) : null;
        const existingEnd = values?.fixedPeriodEndDate ? dayjs(values.fixedPeriodEndDate) : null;
        setStartDate(existingStart);
        setEndDate(existingEnd);
      }
    } else if (open && !values) {
      // Reset for new berth creation
      setStartDate(null);
      setEndDate(null);
      setAllDatesDisabled(false);
    }
  }, [open, mode, values]);

  // Validate duration for monthly bookings
  useEffect(() => {
    if (startDate && endDate && chargeType === "month") {
      const duration = dayjs(endDate).diff(dayjs(startDate), 'day') + 1;
      setAllDatesDisabled(duration < 30);
    } else {
      setAllDatesDisabled(false);
    }
  }, [startDate, endDate, chargeType]);

  const handleConfirm = () => {
    // Prevent confirmation if validation fails
    if (allDatesDisabled) {
      return;
    }

    handleDateSlotSelection(startDate, endDate);
    handleClose();
    return;
  };

  // console.log("array: ", dateArray);

  // const isWeekend = (date) => {
  //   const d1 = dayjs(date).format("YYYY-MM-DD");
  //   const d2 = dayjs(startDate).format("YYYY-MM-DD");
  //   // console.log("D1: ", d1);
  //   // console.log("D2: ", d2);

  //   // console.log("is date match: ", d1 === d2);

  //   return dateArray.includes(d1);
  // };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="BerthDateSlotModal">
        <Grid container className="searchBoxContainer">
          <Typography variant="h5">{title}</Typography>
          <Button
            disabled={startDate === null || endDate === null || allDatesDisabled}
            className="btn"
            variant="contained"
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </Grid>

        {mode === "fixedPrice" && (!availabilityStartDate || !availabilityEndDate) && (
          <div style={{ margin: '16px 0' }}>
            <Alert severity="info">
              Please set the berth availability dates first before selecting the fixed price period.
              The fixed price period must fall within the availability dates.
            </Alert>
          </div>
        )}

        {allDatesDisabled && (
          <div style={{ margin: '16px 0' }}>
            <Alert severity="warning">
              The selected period is too short for a monthly booking.
              Monthly bookings require at least 30 days.
              Please select a longer period or change the pricing type.
            </Alert>
          </div>
        )}

        <Grid container className="datePickerContainer" mt={2} mb={8}>
          <Grid item mt={2} size={{ xs: 12, md: 6 }}>
            <DemoItem label="Start Date">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  // defaultValue={today}
                  disabled={mode === "fixedPrice" && (!availabilityStartDate || !availabilityEndDate)}
                  minDate={minDate}
                  maxDate={maxDate}
                  fullWidth
                  name={"berthAvailableDate"}
                  required
                  value={startDate}
                  onChange={(e) => {
                    console.log("e: ", e)
                    setStartDate(e)
                  }}
                />
              </LocalizationProvider>
            </DemoItem>
          </Grid>
          <Grid item mt={2} size={{ xs: 12, md: 6 }}>
            <DemoItem label="End Date">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  disabled={startDate === null}
                  // defaultValue={today}
                  minDate={startDate}
                  maxDate={maxDate}
                  // shouldDisableDate={isWeekend}
                  fullWidth
                  name={"berthAvailableUntil"}
                  required
                  value={endDate}
                  onChange={(e) => setEndDate(e)}
                />
              </LocalizationProvider>
            </DemoItem>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};
